import { uuid } from "vue-uuid";
import { SESSION_COOKIE } from '@/utils/constants.js'

// Get the session ID
function getSessionId() {
    let sessionId = readCookie(SESSION_COOKIE);
    if (sessionId == "") {
        sessionId = uuid.v1();
        document.cookie = SESSION_COOKIE + "=" + sessionId;
    }
    return sessionId;
}

function readCookie(name) {
    var cname = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(cname) == 0) {
            return c.substring(cname.length, c.length);
        }
    }
    return "";
}

export { getSessionId };
